import { MillOverviewPage } from "./MillOverviewPage";

const MillOverview = () => {
	return <MillOverviewPage />;
};
export default MillOverview;
